<div class="row header-upsell-items" *ngIf="upSellItems && upSellItems.length > 0">
    <div class="p-1 col-6" *ngFor="let item of upSellItems;let i=index;">
        <div class="card cursor fixed-item-height" (click)="onItemClick(item)">

            <img *ngIf="item.item_image" [defaultImage]="defaultImage" [lazyLoad]="item.item_image" alt="image"
                style="width:100%; height: 80px;object-fit: cover;">
            <img *ngIf="!item.item_image" [defaultImage]="defaultImage" [lazyLoad]="defaultItemImage"
                alt="location image" style="width:100%; height: 80px;object-fit: cover;">
            <div class="container">
                <b class="font-size-11">{{item.item_name}}</b>
                <div>
                    <span class="card-text font-size-11 font-weight-bold-500">
                        {{item.item_price.toFixed(2)}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<app-drawer [(visible)]="drawerVisible" (visibleChange)="onDrawerVisibleChange($event)">
    <ng-container *ngIf="drawerVisible && item_pkid">
      <app-ecom-item-details2 [item]="item" [onClose]="onClose" [item_pkid]="item_pkid" [iscvsd_pkid]="iscvsd_pkid"
        [category_pkid]="category_pkid" [upSellId]="upSellId"></app-ecom-item-details2>
    </ng-container>
  </app-drawer>